"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseDateTime = exports.parseDate = exports.formatDateTime = exports.formatDateRange = exports.formatDate = exports.PICKER_DATE_FORMAT = exports.PICKER_DATETIME_FORMAT = exports.HUMAN_DATE_FORMAT = exports.HUMAN_DATETIME_FORMAT = exports.DEFAULT_DATE_FORMAT = exports.DEFAULT_DATETIME_FORMAT = void 0;
var _core = require("@focaltec-suite/core");
var _dateFns = require("date-fns");
var _locale = require("date-fns/locale");
// https://date-fns.org/v2.29.3/docs/format
var DEFAULT_DATE_FORMAT = exports.DEFAULT_DATE_FORMAT = 'dd-MM-yyyy';
var DEFAULT_DATETIME_FORMAT = exports.DEFAULT_DATETIME_FORMAT = 'dd-MM-yyyy HH:mm:ss';
var HUMAN_DATE_FORMAT = exports.HUMAN_DATE_FORMAT = 'P';
var HUMAN_DATETIME_FORMAT = exports.HUMAN_DATETIME_FORMAT = 'P, kk:mm';
var PICKER_DATE_FORMAT = exports.PICKER_DATE_FORMAT = 'dd MMM, yyyy';
var PICKER_DATETIME_FORMAT = exports.PICKER_DATETIME_FORMAT = 'dd MMM, yyyy, kk:mm';
var parseDateTime = exports.parseDateTime = function parseDateTime(input) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DATETIME_FORMAT;
  return parseDate(input, format);
};
var parseDate = exports.parseDate = function parseDate(input) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DATE_FORMAT;
  if (!input) return null;
  return (0, _dateFns.parse)(input, format, new Date());
};
var formatDateTime = exports.formatDateTime = function formatDateTime(_ref) {
  var date = _ref.date,
    _ref$pattern = _ref.pattern,
    pattern = _ref$pattern === void 0 ? DEFAULT_DATETIME_FORMAT : _ref$pattern,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? _locale.es : _ref$locale,
    zone = _ref.zone;
  return formatDate({
    date: date,
    pattern: pattern,
    locale: locale,
    zone: zone
  });
};
var formatDate = exports.formatDate = function formatDate(_ref2) {
  var date = _ref2.date,
    _ref2$pattern = _ref2.pattern,
    pattern = _ref2$pattern === void 0 ? DEFAULT_DATE_FORMAT : _ref2$pattern,
    _ref2$locale = _ref2.locale,
    locale = _ref2$locale === void 0 ? _locale.es : _ref2$locale,
    zone = _ref2.zone;
  if (date) {
    var suffix = '';
    if (zone) {
      suffix = " ".concat((0, _dateFns.format)(date, 'zzzz', {
        locale: locale
      }));
    }
    return "".concat((0, _dateFns.format)(date, pattern, {
      locale: locale
    })).concat(suffix);
  }
  return '';
};
var formatDateRange = exports.formatDateRange = function formatDateRange(from, to, locale) {
  if (!to || to === from) {
    return formatDate({
      date: from,
      locale: locale
    });
  }
  var fFrom = formatDate({
    date: from,
    locale: locale
  });
  var fTo = formatDate({
    date: to,
    locale: locale
  });
  if (fFrom === fTo) {
    return fFrom;
  }
  return (0, _core.translate)('date_ranges.value', {
    from: fFrom,
    to: fTo
  });
};